import { render, staticRenderFns } from "./RetrogradePage.vue?vue&type=template&id=c8133022&scoped=true&"
import script from "./RetrogradePage.vue?vue&type=script&lang=js&"
export * from "./RetrogradePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8133022",
  null
  
)

export default component.exports